import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      enquiry: '',
      isLoading: false,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });

    setTimeout(() => {
      console.log('Form submitted:', this.state);
      this.setState({ isLoading: false, name: '', email: '', enquiry: '' });
    }, 2000);
  };

  render() {
    const { name, email, enquiry, isLoading } = this.state;

    const containerStyle = {
      padding: '30px',
      background: '#fff7f0',
      borderRadius: '12px',
      maxWidth: '600px',
      margin: '40px auto',
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Arial, sans-serif',
    };

    const headerStyle = {
      textAlign: 'center',
      color: '#333',
      marginBottom: '20px',
    };

    const sectionTitle = {
      color: '#555',
      fontSize: '18px',
      margin: '10px 0',
    };

    const labelStyle = {
      display: 'block',
      marginBottom: '6px',
      color: '#444',
      fontWeight: '500',
    };

    const inputStyle = {
      width: '100%',
      padding: '10px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      marginBottom: '15px',
      fontSize: '15px',
    };

    const textAreaStyle = {
      ...inputStyle,
      resize: 'vertical',
    };

    const buttonStyle = {
      background: 'linear-gradient(to right, #ff7e5f, #feb47b)',
      color: 'white',
      padding: '12px 20px',
      border: 'none',
      borderRadius: '30px',
      cursor: 'pointer',
      fontSize: '16px',
      width: '100%',
    };

    return (
      <div style={containerStyle}>
        <h2 style={headerStyle}>Contact Us</h2>

        <div style={{ marginBottom: '25px' }}>
          <h4 style={sectionTitle}>Our Location</h4>
          <p style={{ margin: '2px 0' }}>JC Creations</p>
          <p style={{ margin: '2px 0' }}>36/2, Narayanappa Layout,</p>
          <p style={{ margin: '2px 0' }}>Ramagondanahalli,</p>
          <p style={{ margin: '2px 0' }}>Yelahanka, Bengaluru-560064.</p>
          <p style={{ margin: '2px 0' }}><strong>Telephone:</strong> +91 83107 26160</p>
        </div>

        <div>
          <h4 style={sectionTitle}>Contact Form</h4>

          {isLoading ? (
            <div style={{ textAlign: 'center', margin: '20px 0' }}>
              <CircularProgress color="secondary" />
            </div>
          ) : (
            <form onSubmit={this.handleSubmit}>
              <label style={labelStyle}>Your Name</label>
              <input
                type="text"
                name="name"
                value={name}
                onChange={this.handleChange}
                style={inputStyle}
                required
              />

              <label style={labelStyle}>E-Mail Address</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={this.handleChange}
                style={inputStyle}
                required
              />

              <label style={labelStyle}>Enquiry</label>
              <textarea
                name="enquiry"
                value={enquiry}
                onChange={this.handleChange}
                rows="4"
                style={textAreaStyle}
                required
              />

              <button type="submit" style={buttonStyle}>Submit</button>
            </form>
          )}
        </div>
      </div>
    );
  }
}

export default ContactUs;
